<template>
  <div>
    <el-dialog :title="$t('PersonalCenter.Components.Tips4')" :visible.sync="visible" @cancel="visible=false" width="1200px" v-if="isPC">
      <div class="pc-box">
        <p>{{ $t('PersonalCenter.Components.Tips1') }}</p>
        <p>{{ $t('PersonalCenter.Components.Tips2') }}</p>
        <div class="list-box">
          <el-row>
            <el-col :span="4" v-for="(item,index) in certificateDictValue" :key="index">
              <a :href="item.url" target="_blank" v-if="item.url&&item.url!==''">{{ item.name }}</a>
              <span v-else> {{ item.name }}<i>*</i> </span>
            </el-col>
          </el-row>
        </div>
        <p>{{ $t('PersonalCenter.Components.Tips3') }}</p>
      </div>
    </el-dialog>
    <el-dialog :title="$t('PersonalCenter.Components.Tips4')" :visible.sync="visible" @cancel="visible=false" width="90%" v-else>
      <div class="mobile-box">
        <p>{{ $t('PersonalCenter.Components.Tips1') }}</p>
        <p>{{ $t('PersonalCenter.Components.Tips2') }}</p>
        <div class="list-box">
          <el-row>
            <el-col :span="12" v-for="(item,index) in certificateDictValue" :key="index">
              <a :href="item.url" target="_blank" v-if="item.url&&item.url!==''">{{ item.name }}</a>
              <span v-else> {{ item.name }}<i>*</i> </span>
            </el-col>
          </el-row>
        </div>
        <p>{{ $t('PersonalCenter.Components.Tips3') }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      visible: false,
      certificateDictValue: []
    }
  },
  created() {
    this.getCertificateDictValue()
  },
  methods: {
    show() {
      this.visible = true
    },
    getCertificateDictValue() {
      API.publishGetDictValue({ dictTypeCode: 'data:certification_profile_template' }).then(res => {
        this.certificateDictValue = JSON.parse(res.data)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.pc-box {
  .list-box {
    margin: 50px 0;
    a {
      display: inline-block;
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #000000;
    }
    span {
      display: inline-block;
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #000000;
    }
    .el-col-4 {
      padding-bottom: 24px;
    }
  }
  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #747a87;
  }
}
.mobile-box {
  .list-box {
    margin: 0.4rem 0;
    a {
      display: inline-block;
      font-weight: 400;
      font-size: 0.24rem;
      line-height: 0.42rem;
      color: #000000;
    }
    span {
      display: inline-block;
      font-weight: 400;
      font-size: 0.24rem;
      line-height: 0.42rem;
      color: #000000;
    }
    .el-col-4 {
      padding-bottom: 24px;
    }
  }
  p {
    font-weight: 400;
    font-size: 0.24rem;
    line-height: 0.42rem;
    color: #747a87;
  }
  /ddep/.el-dialog__body {
    padding: 10px 20px;
  }
}
</style>
